import type { EntityType } from '../contract'

/* ERP · cor, rótulo e endereço de cada tipo de entidade. Todo nome de entidade na tela é um link para a ficha. */

export const ENTITY_META: Record<EntityType, { label: string; plural: string; color: string }> = {
    doador: { label: 'Doador', plural: 'Doadores', color: 'var(--t-doador)' },
    igreja: { label: 'Igreja', plural: 'Igrejas', color: 'var(--t-igreja)' },
    evento: { label: 'Evento', plural: 'Eventos', color: 'var(--t-evento)' },
    consultor: { label: 'Consultor', plural: 'Consultores', color: 'var(--t-consultor)' },
    empresa: { label: 'Empresa', plural: 'Empresas', color: 'var(--t-empresa)' },
    embaixador: { label: 'Embaixador', plural: 'Embaixadores', color: 'var(--t-embaixador)' },
    osp: { label: 'OSP', plural: 'OSPs', color: 'var(--t-osp)' },
    crianca: { label: 'Criança', plural: 'Crianças', color: 'var(--t-crianca)' },
}

export const fichaPath = (type: EntityType, id: string) => `/staff/ficha/${type}/${encodeURIComponent(id)}`

export const initialsOf = (name: string) => name.split(/\s+/).filter(w => /^[A-ZÀ-Ú]/.test(w)).slice(0, 2).map(w => w[0]).join('') || '?'
